import type { DocumentLinkPublic, DocumentPublic } from "@common/client"

export function supersededBy(
  document: DocumentPublic,
): DocumentLinkPublic | undefined {
  return document.links?.find(
    (link) => link.link_type === "supersedes" && link.direction === "incoming",
  )
}

export function documentNumber(document: DocumentPublic): string | undefined {
  return document.active_attributes?.document_number ?? undefined
}

export function revision(document: DocumentPublic): string | undefined {
  return document.active_attributes?.revision ?? undefined
}

export function issue(document: DocumentPublic): string | undefined {
  return document.active_attributes?.issue ?? undefined
}

export function revisionLabel(document: DocumentPublic): string | undefined {
  const parts = [revision(document), issue(document)].filter(
    (part): part is string => !!part,
  )
  return parts.length > 0 ? parts.join(" · ") : undefined
}

export function documentTitle(document: DocumentPublic): string {
  return document.active_attributes?.title ?? document.file_name
}

export function ataChapters(document: DocumentPublic): number[] {
  return document.active_attributes?.ata_chapter ?? []
}

export function issuedBy(document: DocumentPublic): string | undefined {
  const manufacturers = document.active_attributes?.manufacturer ?? []
  return (
    document.active_attributes?.issuer ??
    document.active_airworthiness_directive?.issued_by ??
    (manufacturers.length > 0 ? manufacturers.join(", ") : undefined)
  )
}
